import { render, staticRenderFns } from "./WxCarSearch.vue?vue&type=template&id=0fc839e8&scoped=true&"
import script from "./WxCarSearch.vue?vue&type=script&lang=js&"
export * from "./WxCarSearch.vue?vue&type=script&lang=js&"
import style0 from "./WxCarSearch.vue?vue&type=style&index=0&id=0fc839e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc839e8",
  null
  
)

export default component.exports